import React from 'react';

/**
 * Ophilia Logo Component
 * Orange circle outline with two dots (top-left and bottom-right)
 * Transparent background
 */
const Logo = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: { width: 32, height: 32 },
    md: { width: 40, height: 40 },
    lg: { width: 60, height: 60 },
    xl: { width: 80, height: 80 },
    '2xl': { width: 120, height: 120 }
  };

  const { width, height } = sizes[size] || sizes.md;

  // Logo color - Ophilia orange
  const logoColor = '#F8822A';

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 100 100"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Main circle outline */}
      <circle 
        cx="50" 
        cy="50" 
        r="35" 
        stroke={logoColor}
        strokeWidth="10"
        fill="none"
      />
      
      {/* Top-left dot */}
      <circle 
        cx="24" 
        cy="26" 
        r="10" 
        fill={logoColor}
      />
      
      {/* Bottom-right dot */}
      <circle 
        cx="76" 
        cy="74" 
        r="10" 
        fill={logoColor}
      />
    </svg>
  );
};

export default Logo;
